<template>
  <ion-page>
    <ion-header>
      <ion-toolbar style="--background: #FFC107; color: white;">
        <ion-title>Profil Pegawai</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true" class="ion-padding">
      <!-- Logo dan informasi -->
      <div style="display: flex; justify-content: center; align-items: center; padding: 16px 24px; border-bottom: 2px solid #FFC107; margin-bottom: 5px; background-color: #fff;">
        <img src="/assets/icon/logo_desa.svg"
          style="height: 90px; margin-right: 24px;" alt="Logo Desa Cinto Mandi">
        <div>
          <div style="font-weight: bold; font-size: 22px; text-align: left; color: #333;">Pemerintahan Desa Cinto Mandi</div>
          <div style="font-weight: bold; font-size: 18px; text-align: left; color: #555;">Sistem Presensi Digital</div>
          <div style="font-size: 14px; text-align: left; color: #777;">Jl. Raya Desa Cinto Mandi, Kecamatan...</div>
        </div>
      </div>
      
      <!-- Foto Profil -->
      <div class="ion-text-center" style="margin-top: 16px; margin-bottom: 20px;">
        <ion-avatar style="width: 120px; height: 120px; margin: auto;">
          <img v-if="userData?.fotoURL" :src="userData.fotoURL" />
          <img v-else src="https://ionicframework.com/docs/img/demos/avatar.svg" />
        </ion-avatar>
      </div>

      <ion-card v-if="userData">
        <ion-card-header>
          <ion-card-title>Edit Profil</ion-card-title>
          <ion-card-subtitle>{{ userData.role }}</ion-card-subtitle>
        </ion-card-header>

        <ion-card-content>
          <ion-list>
            <!-- FOTO LINK -->
            <ion-item>
              <ion-label position="stacked">URL Foto Profil</ion-label>
              <ion-input v-model="userData.fotoURL" placeholder="https://..." />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Nama Lengkap</ion-label>
              <ion-input v-model="userData.nama" />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Jabatan</ion-label>
              <ion-input v-model="userData.jabatan" />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Username</ion-label>
              <ion-input v-model="userData.username" />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">NIK</ion-label>
              <ion-input v-model="userData.nik" type="number" />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Tanggal Lahir</ion-label>
              <ion-input v-model="userData.ttl" placeholder="DD/MM/YYYY" />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">No HP</ion-label>
              <ion-input v-model="userData.noHp" type="tel" />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Alamat</ion-label>
              <ion-input v-model="userData.alamat" />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Agama</ion-label>
              <ion-input v-model="userData.agama" />
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Status</ion-label>
              <ion-select v-model="userData.status">
                <ion-select-option value="aktif">Aktif</ion-select-option>
                <ion-select-option value="nonaktif">Nonaktif</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-list>

          <ion-button expand="block" @click="updateUser">Simpan</ion-button>
        </ion-card-content>
      </ion-card>

      <ion-note v-else class="ion-text-center">Memuat data pegawai...</ion-note>
    </ion-content>
  </ion-page>
</template>

<script setup>
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
  IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent,
  IonItem, IonLabel, IonInput, IonList, IonSelect, IonSelectOption,
  IonButton, IonAvatar, IonNote, toastController
} from "@ionic/vue";
import { ref, onMounted } from "vue";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import { firebaseApp } from "../views/firebase.js";

const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

const userData = ref(null);
let userId = "";

const fetchUserData = async () => {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      userId = user.uid;
      const userDoc = await getDoc(doc(db, "users", userId));
      if (userDoc.exists()) {
        userData.value = userDoc.data();
      }
    }
  });
};

const updateUser = async () => {
  try {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, userData.value); // Semua field baru ikut tersimpan

    const toast = await toastController.create({
      message: "Data berhasil diperbarui",
      duration: 2000,
      color: "success",
    });
    toast.present();
  } catch (error) {
    const toast = await toastController.create({
      message: "Gagal memperbarui data",
      duration: 2000,
      color: "danger",
    });
    toast.present();
  }
};

onMounted(() => {
  fetchUserData();
});
</script>
